import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import DefaultContainer from '../../components/container/DefaultContainer'
import Header from '../../components/container/Header'
import MainNaviagation from '../../components/navigation/MainNaviagation'
import InnerNaviagation from '../../components/navigation/InnerNaviagation'
import Footer from '../../components/container/Footer'
import AboutContainer from '../../components/container/company/AboutContainer'
import HeaderTitle from '../../components/inner/HeaderTitle'
import { useLanguage } from '../../context/LanguageContext';
import { siteCopy } from '../../i18n/landingCopy';

import backgroundImage from '../../assets/company/CompanyBackgroundImage.png'

import About from './About'
import History from './History'

const Company = () => {
    const { language } = useLanguage();
    const copy = siteCopy[language]?.pages?.company || siteCopy.en.pages.company;

    const CompanyItem = copy.tabs.map((label, index) => ({
      label,
      to: index === 0 ? "about" : "history",
    }));

    return (
        <DefaultContainer>
            <Header headerBackgroundImage={backgroundImage}>
                <MainNaviagation />
                    <HeaderTitle>{copy.title}</HeaderTitle>
                <InnerNaviagation item={CompanyItem}/>
            </Header>
    
            <AboutContainer>
              <Routes>
                <Route path='/' element={<Navigate to="about" replace={true}/> }/>
                <Route path='about' element={<About/>} />
                <Route path='history' element={<History />} />
              </Routes>
            </AboutContainer>
    
            <Footer />
    
        </DefaultContainer>
      )
}

export default Company
